// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class HelpModalService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getHelpPopup(internalName) {
        const urlParams = { internalName };
        const url = this.urlsService.getUrl(this.urlsService.SUPPORT.HELP_POPUP, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
}
HelpModalService.ɵfac = function HelpModalService_Factory(t) { return new (t || HelpModalService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
HelpModalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: HelpModalService, factory: HelpModalService.ɵfac, providedIn: 'root' });
